import { useMemo } from 'react'
import type { JSX } from 'react'

import { Button, Notice } from '@buffer-mono/popcorn'

import { getBrowserGuestDraftStore } from '~publish/helpers/guestDrafts'
import { useGuestDrafts } from '~publish/hooks/useGuestDrafts'

import {
  dismissGuestDraftImportPrompt,
  useGuestDraftImportPrompt,
} from './guestDraftImportPrompt'

export function GuestDraftImportNotice(): JSX.Element | null {
  const prompt = useGuestDraftImportPrompt()
  const store = useMemo(() => getBrowserGuestDraftStore(), [])
  const draftCount = useGuestDrafts(store).drafts.length

  if (!prompt || draftCount === 0) return null

  return (
    <Notice variant="info" onDismiss={dismissGuestDraftImportPrompt}>
      <Notice.Text>
        You have {draftCount} {draftCount === 1 ? 'draft' : 'drafts'} saved in
        this browser.
      </Notice.Text>
      {prompt.organizationName && (
        <Notice.Text>
          They&apos;ll be imported into {prompt.organizationName}.
        </Notice.Text>
      )}
      <Notice.Actions>
        <Button size="small" variant="primary" onClick={prompt.startImport}>
          Import
        </Button>
      </Notice.Actions>
    </Notice>
  )
}
